import axios from "axios";
import "../config";

export default {
  async create(data) {
    return axios.post("/spotlights", data);
  },
  async update(data) {
    return axios.put("/spotlights", data);
  },
  async delete({ id }) {
    return axios.delete(`/spotlights/${id}`);
  },
  async setActiveSpotlight({ id }) {
    return axios.put(`/spotlights/${id}/activate`);
  },
  async deactivateSpotlight(data)  {
    return axios.put('spotlights/deactivate', data);
  },
  async upload(formData) {
    const instance = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        "content-type": "multipart/form-data;",
      },
    });
    return instance.post("/spotlights/upload", formData);
  },
};
